import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    q: 'What is HiveeClub Rewards?',
    a: 'HiveeClub Rewards is a membership that allows you to earn points, redeem rewards, receive member exclusive gifts and promotions, and the latest events. Signing up is free. Please refer to the HiveeClub Terms and Conditions for full details.'
  },
  {
    q: 'How do I earn HiveeClub Rewards points?',
    a: `There are now more ways to earn points! Points can be earned regularly through:\n\na. Every A$1 spent = 1 point\nb. Bonus Points (e.g. Birthday +100 points and other promotions)\n\nOne-time bonus points:\na. Upon creation of HiveeClub account = 10 points\nb. Completion of HiveeClub Profile bonus = 20 points`
  },
  {
    q: 'How do I check my points balance?',
    a: 'To check your HiveeClub Points balance, simply login the HiveeClub App, click on "Rewards" – "Points history" to view your rewards points information.'
  },
  {
    q: 'How can I burn my Points?',
    a: 'Redeem exclusive rewards and more over at Rewards Store! Turn on your notification to receive updates when new Rewards are available. No purchase is required when redeeming in app.'
  },
  {
    q: 'What are the different HiveeClub Rewards Tiers?',
    a: `There are three different HiveeClub Rewards Tiers: Gold, Platinum, and Diamond!\n\n⭐ Gold Tier: Simply sign up for HiveeClub.\n\n💜 Platinum Tier: Spend an accumulated value of $3,000 within 12 months of signing up. Status is valid for a 12 month period.\n\n💙 Diamond Tier: Spend an accumulated value of $6,000 within 12 months of getting qualified for Platinum Member Status. Status is valid for a 12 month period.`
  },
  {
    q: 'How long does it take for points to be credited?',
    a: 'After your order has been completed, your points will show up in your account straight away.'
  },
  {
    q: 'Still notice discrepancies in your points?',
    a: "Don't worry, we've got you! Contact our Customer Service Team via the Contact page and we'll sort it out for you."
  },
  {
    q: 'How do I redeem HiveeClub Rewards?',
    a: `To redeem rewards in app, follow these 5 simple steps:\n\n1. Log in to your HiveeClub Account, and click on "Rewards"\n2. Click on "Rewards Store", and choose from "Product Rewards" and "Ticket Rewards"\n3. Select the product or ticket you'd like to redeem\n4. When you are ready to place your order, click on "Purchase with Points" to complete your purchase\n5. After checkout, you can click on "View my rewards" to check your product rewards or ticket rewards`
  },
  {
    q: 'Are there Terms and Conditions for the rewards I redeem?',
    a: 'Items may vary every month and will be available while stocks last. The rewards on offer are subject to change, alteration, or termination by HiveeClub at its sole discretion at any time.\n\nOther Terms and Conditions:\n– You cannot redeem more than 10 tickets for the same event.'
  },
  {
    q: 'Will my tier be downgraded if I use my points?',
    a: 'Redeeming your HiveeClub Rewards points will not affect your tier progress or qualification. You will continue enjoying your tier benefits as long as you meet the yearly minimum total spend required for the tier.'
  },
  {
    q: 'How can I maintain my Tier Status?',
    a: 'To maintain your HiveeClub Rewards status, you must continue to meet the minimum spend for your tier within 365 days of qualifying for that tier.\n\n💠 Diamond Members: spend $6,000 or more within 12 months to maintain your status.\n💎 Platinum Members: spend $3,000–$5,999 to maintain your status.\n\nIn the event you do not meet the minimum requirement, your membership will be adjusted to reflect the tier your spend has qualified you for.'
  },
  {
    q: 'Will I continue to earn points if I use a promo code?',
    a: 'Not to worry! Your purchase with a promo code still entitles you to:\n– Earn your HiveeClub Rewards points\n– Accumulate spend towards achieving or maintaining your HiveeClub Rewards tier status'
  },
  {
    q: 'Can I return Rewards?',
    a: 'Unfortunately, rewards may not be returned or exchanged for points, cash, another reward, gift cards, or gift certificates.\n\nThis is subject to any rights you may have as a consumer at law.'
  },
];

function FAQItem({ faq, index }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item ${open ? 'open' : ''}`}>
      <button className="faq-question" onClick={() => setOpen(!open)}>
        <span className="faq-q-text">{faq.q}</span>
        <span className="faq-arrow">{open ? '−' : '+'}</span>
      </button>
      {open && (
        <div className="faq-answer">
          {faq.a.split('\n').map((line, i) => (
            <p key={i}>{line || '\u00A0'}</p>
          ))}
        </div>
      )}
    </div>
  );
}

export default function FAQ({ navigate }) {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Earning Points', 'Rewards', 'Tiers', 'General'];

  return (
    <div className="faq-page">
      <div className="page-banner">
        <div className="container">
          <h1>FAQs</h1>
          <p>Everything you need to know about HiveeClub Rewards</p>
        </div>
      </div>

      <section className="faq-section">
        <div className="container">
          <div className="faq-hero-cards">
            {[
              { label: 'Gold', sub: 'Free signup', gemColors: ['#FFE066','#D4A017','#FFF3A0'], textColor: '#f5c842' },
              { label: 'Platinum', sub: '$3,000 / 12mo', gemColors: ['#D4BFFF','#8B5FD4','#EDE0FF'], textColor: '#b89fff' },
              { label: 'Diamond', sub: '$6,000 / 12mo', gemColors: ['#7DD3FC','#0EA5E9','#BAE8FF'], textColor: '#60c0ff' },
            ].map(t => (
              <div key={t.label} className="tier-mini-card">
                <svg viewBox="0 0 60 52" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="14,3 30,3 22,18 4,18" fill={t.gemColors[2]} opacity="0.9"/>
                  <polygon points="30,3 46,3 56,18 38,18" fill={t.gemColors[0]} opacity="0.85"/>
                  <polygon points="14,3 46,3 38,18 22,18" fill={t.gemColors[0]}/>
                  <polygon points="4,18 22,18 30,49" fill={t.gemColors[1]} opacity="0.8"/>
                  <polygon points="22,18 38,18 30,49" fill={t.gemColors[0]} opacity="0.95"/>
                  <polygon points="38,18 56,18 30,49" fill={t.gemColors[1]} opacity="0.7"/>
                  <polygon points="14,3 46,3 56,18 30,49 4,18" fill="none" stroke={t.gemColors[0]} strokeWidth="1.2" opacity="0.6"/>
                  <line x1="22" y1="18" x2="30" y2="49" stroke="rgba(255,255,255,0.25)" strokeWidth="0.8"/>
                  <line x1="38" y1="18" x2="30" y2="49" stroke="rgba(255,255,255,0.25)" strokeWidth="0.8"/>
                  <line x1="4" y1="18" x2="56" y2="18" stroke="rgba(255,255,255,0.3)" strokeWidth="0.8"/>
                </svg>
                <strong style={{ color: t.textColor }}>{t.label}</strong>
                <small>{t.sub}</small>
              </div>
            ))}
          </div>

          <div className="faq-list">
            {faqs.map((faq, i) => (
              <FAQItem key={i} faq={faq} index={i} />
            ))}
          </div>

          <div className="faq-cta">
            <p>Still have questions?</p>
            <button className="btn-primary" onClick={() => navigate('contact')}>
              Contact Our Team →
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
